export default theme => ({
  date_picker: {
    minWidth: 134,
  },
});
